export default __webpack_public_path__ + "static/media/avatar-1.04cf10a9.png";